package com.essntl.uikit.components.button.primary

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import com.essntl.uikit.components.button.EsButton
import com.essntl.uikit.components.button.EsButtonColors
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.theme.EsColorScheme
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsLargePrimaryButton(
    onClick: () -> Unit,
    text: String,
    prefixIconRes: String? = null,
    suffixIconRes: String? = null,
    shape: Shape = RoundedCornerShape(EsConstants.ButtonBorderRadius),
    enabled: Boolean = true,
    loading: Boolean = false,
    withFocusBorder: Boolean = true,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsButton(
        onClick = onClick,
        size = EsButtonSize.Large,
        colors = getPrimaryButtonColors(essntlColorScheme),
        text = text,
        shape = shape,
        prefixIconRes = prefixIconRes,
        suffixIconRes = suffixIconRes,
        enabled = enabled,
        loading = loading,
        withFocusBorder = withFocusBorder,
        interactionSource = interactionSource,
        modifier = modifier,
    )
}

internal fun getPrimaryButtonColors(esColorScheme: EsColorScheme) = EsButtonColors(
    containerColor = esColorScheme.primary,
    disabledContainerColor = esColorScheme.primaryDisabled,
    pressedContainerColor = esColorScheme.primaryPressed,
    hoveredContainerColor = esColorScheme.primaryHover,
    focusedContainerColor = esColorScheme.primary,
    textColor = esColorScheme.textContrast,
    disabledTextColor = esColorScheme.textDisabled,
    iconColor = esColorScheme.iconContrast,
    disabledIconColor = esColorScheme.iconDisabled,
    borderFocusColor = esColorScheme.borderFocus,
)

internal fun getPrimaryButtonColorsAlternate(esColorScheme: EsColorScheme) = EsButtonColors(
    containerColor = Color.Black,
    disabledContainerColor = esColorScheme.primaryDisabled,
    pressedContainerColor = esColorScheme.primaryPressed,
    hoveredContainerColor = esColorScheme.primaryHover,
    focusedContainerColor = Color.Black,
    textColor = esColorScheme.textContrast,
    disabledTextColor = esColorScheme.textDisabled,
    iconColor = esColorScheme.iconContrast,
    disabledIconColor = esColorScheme.iconDisabled,
    borderFocusColor = esColorScheme.borderFocus,
)

@Composable
fun EsLargePrimaryButtonAlternate(
    onClick: () -> Unit,
    text: String,
    prefixIconRes: String? = null,
    suffixIconRes: String? = null,
    enabled: Boolean = true,
    loading: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsButton(
        onClick = onClick,
        size = EsButtonSize.Large,
        colors = getPrimaryButtonColorsAlternate(essntlColorScheme),
        text = text,
        prefixIconRes = prefixIconRes,
        suffixIconRes = suffixIconRes,
        enabled = enabled,
        loading = loading,
        interactionSource = interactionSource,
        modifier = modifier,
    )
}